import {
	PRIVATE_FREEFORM_API_KEY_ENV,
	PRIVATE_FREEFORM_API_VERSION_ENV,
	PUBLIC_API_URL_ENV,
} from 'tools/environments';

import { GetSectionByIdResponse } from './types';

export const getSectionById = async (
	sectionId: number
): Promise<GetSectionByIdResponse> => {
	const apiUrl = `${PUBLIC_API_URL_ENV}/helpcentre/sectionbyid?sectionId=${sectionId}`;

	const response: any = await fetch(apiUrl, {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
			'Ocp-Apim-Subscription-Key': `${PRIVATE_FREEFORM_API_KEY_ENV}`,
			'Api-Version': `${PRIVATE_FREEFORM_API_VERSION_ENV}`,
		},
	})
		.then((res) => res.json())
		.catch((error) => {
			console.error('Error fetching section by id:', error);
			return null;
		});

	return response;
};
